'use client'

import type { colors } from './switchStyles'

export type SwitchColor = keyof typeof colors

export { Switch } from './Switch'
export { SwitchField } from './SwitchField'
export { SwitchGroup } from './SwitchGroup'
